export const getNotApplicableField = (category: string) => {
  return category + '-na'
}
